/* tslint:disable */

declare var Object: any;
export interface ERPutilInterface {
  "id"?: number;
}

export class ERPutil implements ERPutilInterface {
  "id": number;
  constructor(data?: ERPutilInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPutil`.
   */
  public static getModelName() {
    return "ERPutil";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPutil for dynamic purposes.
  **/
  public static factory(data: ERPutilInterface): ERPutil{
    return new ERPutil(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPutil',
      plural: 'ERPutils',
      path: 'ERPutils',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPutil.ts